import React, { useEffect, useState } from 'react';

import ModalGauge from 'pages/NewRefuel/RefuelContainer/ModalGauge';
import { useMediaQuery } from 'react-responsive';
import BaseSelected from '../../RefuelContainer/components/BaseSelected';
import FuelLevelSelect from '../../RefuelContainer/components/FuelLevelSelect';

import { useNewRefuel } from '../../hooks/useNewRefuel';

import { getImageGasLevel } from './getImageGasLevel';

import {
  Container,
  SelectBasesWrap,
  RefuelFormWrap,
  HeaderCard,
  CardTitle,
  CardSubTitle,
  BasesContainer,
  FuelLevelWrapper,
  FuelCardHeader,
  ModalInfoButton,
  CardFuelWrapper,
  GasImg,
  ModalStyled,
} from './styles';

const FuelLevel: React.FC = () => {
  const [fuelLevelValue, setFuelLevelValue] = useState<number | undefined>(0);
  const [showModaLGauge, setShowModaLGauge] = useState(false);

  const isMobile = useMediaQuery({ maxWidth: 768 });

  const {
    selectedBases,
    selectedBase,
    refuelData,
    handlePercentage,
    stepError,
  } = useNewRefuel();

  const Img = getImageGasLevel(fuelLevelValue || 0);

  const handleChangeValue = (value: number | string): void => {
    setFuelLevelValue(Number(value));
    if (selectedBase?.name) {
      handlePercentage(selectedBase?.name, String(value));
    }
  };

  useEffect(() => {
    const idx = refuelData.findIndex(
      (item) => item.baseName === selectedBase?.name
    );

    if (idx !== -1) {
      setFuelLevelValue(Number(refuelData[idx].currentPercentage));
    } else {
      setFuelLevelValue(undefined);
    }
  }, [refuelData, selectedBase]);

  return (
    <Container>
      <SelectBasesWrap>
        <BasesContainer>
          {!isMobile && selectedBases.length > 0 && (
            <>
              {selectedBases.map((base) => (
                <BaseSelected
                  key={base.name}
                  isSelected={base.name === selectedBase?.name}
                  baseName={base.name}
                  nickName={base.nickname}
                  address={`${base.address}, ${base.number} - ${base.complement}`}
                  isComplete={base.percentageValidate}
                  isError={stepError === 2 && !base?.percentageValidate}
                />
              ))}
            </>
          )}
        </BasesContainer>
      </SelectBasesWrap>
      <RefuelFormWrap>
        <HeaderCard>
          <CardTitle>Informe o nível do seu gás atual (%)</CardTitle>
          <CardSubTitle>
            Para evitar o risco de ficar sem gás, recomendamos que o
            abastecimento seja feito ao atingir 80% da capacidade necessária.
            Isso garante uma programação precisa e mais agilidade.
          </CardSubTitle>
        </HeaderCard>
        <FuelLevelWrapper>
          <FuelCardHeader>
            <ModalInfoButton onClick={() => setShowModaLGauge(true)}>
              Onde verifico o nível do meu gás?
            </ModalInfoButton>
          </FuelCardHeader>
          <CardFuelWrapper>
            <FuelLevelSelect
              fuelLevelValue={fuelLevelValue}
              handleChangeValue={handleChangeValue}
              isError={stepError === 2 && fuelLevelValue === undefined}
            />
            <GasImg src={Img} alt="Fuel Level" />
          </CardFuelWrapper>
        </FuelLevelWrapper>
      </RefuelFormWrap>
      <ModalStyled
        show={showModaLGauge}
        onHide={() => setShowModaLGauge(false)}
        animation={false}
        centered
      >
        <ModalGauge closeModal={() => setShowModaLGauge(false)} />
      </ModalStyled>
    </Container>
  );
};

export default FuelLevel;
